import { useState } from "react";
import { cn } from "@/lib/utils";
import { isGeneratedAvatar, personInitials } from "@/utils/brandLogo";

interface UserAvatarProps {
  src?: string | null;
  name?: string | null;
  /** Size, shape and text size; the parent usually sizes it. */
  className?: string;
}

/**
 * A person's photo with an initials fallback in the brand's colour tokens,
 * so it follows the white-label theme like everything else in the shell.
 * Generated letter avatars stored by older signups count as "no photo".
 */
export function UserAvatar({ src, name, className }: UserAvatarProps) {
  const [failed, setFailed] = useState(false);
  const label = name?.trim() || "Profile";
  if (src && !failed && !isGeneratedAvatar(src)) {
    return (
      <img
        src={src}
        alt={label}
        onError={() => setFailed(true)}
        className={cn("rounded-full object-cover", className)}
      />
    );
  }
  return (
    <span
      role="img"
      aria-label={label}
      className={cn(
        "flex items-center justify-center rounded-full bg-brand-600 text-brand-contrast font-semibold select-none",
        className
      )}
    >
      {personInitials(name)}
    </span>
  );
}
